import * as Actions from './constants'
import { dataKeys, storageKeys } from '../../constants/storage'
import * as Storage from '../../utils/storage';

let token = localStorage.getItem(storageKeys.TOKEN) ? atob(localStorage.getItem(storageKeys.TOKEN)) : null
if (token) {
  token = token.replace(/['"]+/g, '')
}
let user = localStorage.getItem(storageKeys.USER) ? atob(localStorage.getItem(storageKeys.USER)) : null
if (user) {
  user = JSON.parse(Storage.getString(storageKeys.USER))
}
let roles = localStorage.getItem(storageKeys.ROLE) ? atob(localStorage.getItem(storageKeys.ROLE)) : null
if (roles) {
  roles = JSON.parse(Storage.getString(storageKeys.ROLE))
}
let photo = localStorage.getItem(dataKeys.PHOTO) ? localStorage.getItem(dataKeys.PHOTO) : null
if (photo) {
  photo = JSON.parse(localStorage.getItem(dataKeys.PHOTO))
}
let branchShopCurrent = localStorage.getItem(storageKeys.BRANCH_SHOP) ? localStorage.getItem(storageKeys.BRANCH_SHOP) : null
if (branchShopCurrent) {
  branchShopCurrent = JSON.parse(Storage.getString(storageKeys.BRANCH_SHOP))
  
  let photob = localStorage.getItem(storageKeys.BRANCH_SHOP_PHOTO) ? localStorage.getItem(storageKeys.BRANCH_SHOP_PHOTO) : null
  if (photob) {
    photob = JSON.parse(localStorage.getItem(storageKeys.BRANCH_SHOP_PHOTO))
    branchShopCurrent.photo = photob
  }
}
const initState = {
  user: user ? user : null,
  token: token,
  roles: roles,
  photo: photo,
  branchShopCurrent: branchShopCurrent,
  lang: 'en',
  registerInfo: {
    level: '',
    firstName: '',
    lastName: '',
    dob: '',
    primaryEmail: '',
    fullName: null,
    passcodeTime: false,
  },
}

export default function authReducer(state = initState, action = {}) {
  switch (action.type) {
    case Actions.LOGIN_SUCCESS:
      return {
        user: action.payload.user,
        token: action.payload.token,
        photo: action.payload.photo,
        branchShopCurrent: action.payload.branchShopCurrent,
      }
    case Actions.PHOTO_USER:
      return {
        ...state,
        photo: action.payload,
      }
    case Actions.BRANCH_SHOP_USER:
      return {
        ...state,
        branchShopCurrent: action.payload,
      }
    case Actions.USER_ACCESS_USER:
      return {
        ...state,
        roles: action.payload,
      }
    case Actions.LOGIN_TOKEN:
      return {
        ...state,
        token: action.payload,
      }
    case Actions.RESTORE_USER:
      return {
        ...state,
        user: action.payload,
      }
    case Actions.UPDATE_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          donorThumbnailPath: action.payload,
        },
      }
    case Actions.UPDATE_PASSCODE:
      return {
        ...state,
        user: {
          ...state.user,
          passcodeTime: action.payload,
        },
      }
    case Actions.UPDATE_LASTACCESSCOMPANY:
      return {
        ...state,
        user: {
          ...state.user,
          lastAccessCompany: action.payload,
        },
      }
    case Actions.SET_REGISTER_INFO:
      return {
        ...state,
        registerInfo: action.payload,
      }
    case Actions.CHANGE_LANGAUGE:
      return {
        ...state,
        lang: action.payload,
      }
    default:
      return state
  }
}
